import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  compose, get, padCharsStart, size, toNumber, toString,
} from 'lodash/fp';
import { TextField } from '../../common/components';

const areEqual = (prevProps, nextProps) => (
  prevProps.field.value === nextProps.field.value
  && prevProps.field.name === nextProps.field.name
  && prevProps.form.dirty === nextProps.form.dirty
  && (get(prevProps.field.name, prevProps.form.errors)
    === get(nextProps.field.name, nextProps.form.errors))
  && (get(prevProps.field.name, prevProps.form.touched)
    === get(nextProps.field.name, nextProps.form.touched))
);

const S = {
  TextField: styled(TextField)`
    width: 55px;
    margin: 0 0.5rem;
    input[type="number"]::-webkit-outer-spin-button, input[type="number"]::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    input[type="number"] {
      -moz-appearance: textfield;
    }
    .input {
      padding: 0 0.5rem;
      text-align: center;
    }
  `,
};

const IssueNumberField = React.memo(({ field: { onChange, ...field }, form, ...otherProps }) => {
  const error = useMemo(
    () => !!(get(field.name, form.errors) && get(field.name, form.touched)),
    [field.name, form.errors, form.touched],
  );
  const handleChange = useCallback((event) => {
    const length = compose(
      size, toString, toNumber,
    )(event.target.value);

    if (/^\d+$/.test(event.target.value) && length <= 3) {
      const formattedValue = padCharsStart('0', 3, toNumber(event.target.value));
      const formattedEvent = {
        ...event,
        target: { ...event.target, value: formattedValue, name: event.target.name },
      };

      onChange(formattedEvent);
    }
  }, [onChange]);

  return (
    <S.TextField
      {...field}
      {...otherProps}
      onChange={handleChange}
      inputProps={{
        type: 'number',
        placeholder: '000',
        max: 999,
        min: 0,
      }}
      error={error}
      autoFocus
    />
  );
}, areEqual);

IssueNumberField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.shape({}),
    ]).isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.shape({
      number: PropTypes.shape({
        issueNumber: PropTypes.string,
      }),
    }).isRequired,
    touched: PropTypes.shape({
      number: PropTypes.shape({
        issueNumber: PropTypes.bool,
      }),
    }).isRequired,
  }).isRequired,
};

export default IssueNumberField;
